'use client';

import { useEffect } from 'react';

const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'ref',
];

/**
 * Hook to capture and persist marketing attribution parameters.
 * Stores them in session storage so they can be sent with 
 * conversion events even if the user navigates away.
 */
export function useUTM() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const urlParams = new URLSearchParams(window.location.search);
    const captured: Record<string, string> = {};

    UTM_PARAMS.forEach((param) => {
      const value = urlParams.get(param);
      if (value) {
        captured[param] = value;
        // Also save to session storage for persistence across the session
        sessionStorage.setItem(`bioinfometrics_${param}`, value);
      }
    });

    if (Object.keys(captured).length > 0) {
      console.debug('[UTM] Captured attribution:', captured);
    }
  }, []);

  return getStoredAttribution();
}

/**
 * Utility to retrieve stored attribution for conversion events.
 */
export function getStoredAttribution() {
  if (typeof window === 'undefined') return {};
  
  const attribution: Record<string, string> = {};
  UTM_PARAMS.forEach((param) => {
    const value = sessionStorage.getItem(`bioinfometrics_${param}`);
    if (value) attribution[param] = value;
  });
  
  return attribution;
}
